import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './App.scss';
import LoginPage from './pages/login-page/Login';
import HomePage from './pages/home-page/Home';
import Layout from './components/layout/Layout';
import TrainingPage from './pages/Training-page/Training-page';
import SupportPage from './pages/Support-page/Support-page';
import VickiPage from './pages/Vicki-page/Vicki-page';
import OrderPage from './pages/Order-page/Order-page';
import ProductSpecsPage from './pages/Product-specs-page/Product-specs-page';
import FaqPage from './pages/FAQ-page/FAQ-page';
import BestPracticesPage from './pages/Best-practices-page/Best-practices-page';
import PlanogramPage from './pages/Planogram-page/Planogram-page';
import WebinarPage from './pages/Webinar-page/Webinar-page';

function App() {
    const [isAuth, setIsAuth] = useState(false);
    const [authLoading, setAuthLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const storedUserId = localStorage.getItem('vickiUserId');
        const storedToken = localStorage.getItem('access_token');

        if (!storedUserId || !storedToken) return;

        setIsAuth(true);
    }, []);

    const loginHandler = async (authData) => {
        setAuthLoading(true);
        setError(null);

        try {
            const response = await fetch('https://viatouchmedia-test.apigee.net/loyalty/pf-landing/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: authData.username,
                    password: authData.password
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Invalid username or password!');
            }

            const userData = await response.json();
            localStorage.setItem('access_token', userData.access_token);
            localStorage.setItem('vickiUserId', userData.username);
            setIsAuth(true);
        } catch (err) {
            setIsAuth(false);
            setError(err.message);
        } finally {
            setAuthLoading(false);
        }
    };

    if (!isAuth) {
        return (
            <Routes>
                <Route
                    path="*"
                    element={<LoginPage onLogin={loginHandler} loading={authLoading} error={error} />}
                />
            </Routes>
        );
    }

    return (
        <Layout>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<VickiPage />} />
                <Route path="/training" element={<TrainingPage />} />
                <Route path="/order" element={<OrderPage />} />
                <Route path="/product-specs" element={<ProductSpecsPage />} />
                <Route path="/planogram" element={<Navigate to="/planogram/3-0" replace />} />
                <Route path="/planogram/3-0" element={<PlanogramPage />} />
                <Route path="/planogram/4-0" element={<PlanogramPage />} />
                <Route path="/planogram/4-0-tanning" element={<PlanogramPage />} />
                <Route path="/best-practices" element={<BestPracticesPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/support" element={<SupportPage />} />
                <Route path="/webinar" element={<WebinarPage />} />
                <Route path="*" element={null} />
            </Routes>
        </Layout>
    );
}

export default App;
